

export function handleAsyncError(context, fn) {
    return function (...args) {
      return fn(...args).catch((error) => {


        if (Object.hasOwn(error, 'response')) {
          if (Object.hasOwn(error.response, 'data')) {
              if (Object.hasOwn(error.response.data, 'code')) {
                  if (error.response.data.code === 'INVALID_TOKEN') {
                    context.commit('logout')
                    // TODO this.$router.push({name: 'AuthIn'})
                  }
              }
          }
      } else {
        console.error('Unhandled Error:', error);
      }
        // Manually trigger the global error handler 
        /*
        if (this.$root && this.$root.$options.errorHandler) {
          this.$root.$options.errorHandler(error, this, fn.name);
        } else {
          console.error('Unhandled Error:', error);
        }*/

      });
    };
  }